// inspiration: https://github.com/egoist/vue-slim-tabs/blob/master/src/index.js
import Vue from 'vue';
export default Vue.extend({
    data() {
        return {
            activeIndex: 0
        };
    },
    methods: {
        selectTab(index) {
            if (this.activeIndex !== index) {
                this.activeIndex = index;
                this.$emit('tab-changed', index);
            }
        }
    },
    render(createElement) {
        const tabs = this.$slots.default.filter(component => {
            return component.componentOptions && component.componentOptions.tag === 'bf-tab';
        }).map((tab, index) => {
            if (tab) {
                tab.componentOptions.propsData.active = index === this.activeIndex;
            }
            return tab;
        });
        const tabList = tabs
            .map((child, index) => {
            const { title, active } = child.componentOptions.propsData;
            return createElement('li', {
                key: index,
                on: { click: () => this.selectTab(index) },
                class: {
                    active
                }
            }, title ? title : 'untitled');
        });
        const list = createElement('ul', { class: ['tab-list'] }, tabList);
        const contentPanel = createElement('div', { key: this.activeIndex, class: ['content'] }, tabs);
        return createElement('div', { class: ['tabs'] }, [list, contentPanel]);
    }
});
